import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UrlHelperService } from '@core/services/url-helper.service';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { BaseComponent } from '@core/models/base-component.model';
import { AppBarModule } from '@progress/kendo-angular-navigation';
import { ButtonModule } from '@progress/kendo-angular-buttons';

@Component({
    selector: 'app-footer-bar',
    imports: [AppBarModule, ButtonModule],
    templateUrl: './footer-bar.component.html',
    styleUrls: ['./footer-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterBarComponent extends BaseComponent implements OnInit {

  @Input() organizationName: string;
  @Input() buildNumber: string;
  @Input() webServer: string;

  constructor(private http: HttpClient, private url: UrlHelperService) { super(); }

  ngOnInit(): void {
    if (this.organizationName == null) {
      this.organizationName = "";
    }
  }

  healthCheck() {
    var baseUrl = this.url.getApiUrl();

    this.http.get(baseUrl + "ServerStatus/HealthCheck")
      .pipe(takeUntil(this.subscription))
      .subscribe((data) => {
        console.log(data);
    });
  }

}
